import { useFormContext, Controller } from 'react-hook-form';
// @mui
import TextField, { TextFieldProps } from '@mui/material/TextField';

// ----------------------------------------------------------------------

type Props = TextFieldProps & {
  name: string;
};

export default function RHFTextField({ name, helperText, type, ...other }: Props) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          fullWidth
          type={type}
          // defaultValue={type === 'number' ? 0 : ''}
          value={type === 'number' && field.value === 0 ? '0' : field.value}
          // value={type === 'number' && field.value === 0 ? '' : field.value}
          // value={field.value}
          onChange={(event) => {
            let newValue: number | string = event.target.value;
            if (type === 'number') {
              newValue = newValue === '' ? '' : Number(newValue);
            } else if (['phone', 'administrative_phone', 'deliveryPersonPhone'].includes(name)) {
              const numberRegex = /^[\d\s+()-]*$/;
              newValue = numberRegex.test(newValue)
                ? newValue
                : newValue.replace(/[^\d\s+()-]/g, '');
            }
            field.onChange(newValue);
          }}
          error={!!error}
          helperText={error ? error?.message : helperText}
          {...other}
        />
      )}
    />
  );
}
